export var BoutonDefaultProps = {
    disabled: false,
    isLoading: false,
    taille: "md",
    type: "button",
    icone: undefined,
    iconePosition: undefined,
    className: undefined,
    niveau: "secondaire"
};
